export default __webpack_public_path__ + "images/bank-logos/nordea.png";